import UserListItem from "./styles";
import { formatUserList } from "./model";

export default UserListItem;
export { formatUserList };
